<!-- Step: searchForTransferCompany -->
@if (currentStep == steps.searchForTransferCompany) {
  <panel width="450">
    @if (toCompany === null) {
      <list-view [selectable]="false">
        <list-item alert statusIcon="exclamation-triangle">{{ 'transfer-wizard.search-for-company.not-found' | translate }}</list-item>
      </list-view>
    }
    <h1>{{ 'transfer-wizard.search-company.header' | translate }}</h1>
    @if (validationErrorsFromCompany.length > 0) {
      @for (error of validationErrorsFromCompany; track error) {
        <list-view>
          <list-item alert>{{('transfer-wizard.search-company.validation-error.' + error) | translate}}</list-item>
        </list-view>
      }
    }
    <section>
      <custom-input [label]="'transfer-wizard.search-company.vatnumber' | translate" [inputType]="inputTypeEnum.Number" [(value)]="searchVatNumber" />
    </section>
    <section>
      <button #searchVatButton [active]="!loading && searchVatNumber.length == 8 && validationErrorsFromCompany.length === 0" [ignoreValidation]="true" (click)="searchVat()">{{ 'transfer-wizard.search-company.search-vatnumber' | translate }}</button>
    </section>
  </panel>
}

<!-- Step: confirmCompany -->
@if (currentStep == steps.confirmCompany && toCompany) {
  <panel width="450">
    <h1>{{ 'transfer-wizard.confirm-company.header' | translate }}</h1>
    @if (validationErrorsToCompany.length > 0) {
      @for (error of validationErrorsToCompany; track error) {
        <list-view>
          <list-item alert>{{('transfer-wizard.confirm-company.validation-error.' + error) | translate}}</list-item>
        </list-view>
      }
    }
    @if (validationWarningsToCompany.length > 0) {
      @for (warn of validationWarningsToCompany; track warn) {
        <list-view>
          <list-item warning>{{('transfer-wizard.confirm-company.validation-warning.' + warn) | translate}}</list-item>
        </list-view>
      }
    }
    <h2>{{ (toCompanyExistsInGorm ? 'transfer-wizard.confirm-company.existing-company' : 'transfer-wizard.confirm-company.new-company') | translate }}</h2>
    <section>
      <div>{{ (toCompanyExistsInGorm ? 'transfer-wizard.confirm-company.existing-company-text' : 'transfer-wizard.confirm-company.new-company-text') | translate }}</div>
    </section>
    <company-information [company]="toCompany" />
    @if (toCompany.companyContacts.length === 0 && newContact) {
      <section>
        <div>{{ 'transfer-wizard.confirm-company.create-primary-contact' | translate }}</div>
        <contact [contact]="newContact" />
      </section>
    }
    @if (toCompany.companyContacts.length > 0) {
      <list-contact [enableEdit]="false" [company]="toCompany" />
    }
    <section>
      <button ghost [loader]="false" [ignoreValidation]="true" (click)="previousStep()">{{ 'transfer-wizard.previous-step' | translate }}</button>
      <button [active]="validationErrorsToCompany.length === 0 && (toCompany.companyContacts.length > 0 || isNewContactValid())" [loader]="false" [ignoreValidation]="true" (click)="nextStep()">{{ 'transfer-wizard.next-step' | translate }}</button>
    </section>
  </panel>
}

<!-- Step: selectPlans -->
@if (currentStep == steps.selectPlans) {
  <panel width="700">
    <h1>{{ 'transfer-wizard.select-plans.header' | translate }}</h1>
    @if (validationErrorsForPlans.length > 0) {
      @for (error of validationErrorsForPlans; track error) {
        <list-view>
          <list-item alert>{{('transfer-wizard.select-plans.validation-error.' + error) | translate}}</list-item>
        </list-view>
      }
    }
    @if (!rootPlans) {
      <skeletons [defaultSkeletons]="3" />
    }
    <ng-container *ngTemplateOutlet="companyPlansList; context:{ plans: rootPlans, review: false }" />
    <section>
      <button ghost [loader]="false" [ignoreValidation]="true" (click)="previousStep()">{{ 'transfer-wizard.previous-step' | translate }}</button>
      <button [loader]="false" [active]="selectedPlans.length > 0 && validationErrorsForPlans.length == 0" [ignoreValidation]="true" (click)="nextStep()"> {{ (selectedPlans.length === 0 ? 'transfer-wizard.select-plans' : 'transfer-wizard.selected-plans') | translate }} </button>
    </section>
  </panel>
}

<!-- Step: uploadDocument -->
@if (currentStep == steps.uploadDocument) {
  <panel width="450">
    <h1>{{ 'transfer-wizard.upload.header' | translate }}</h1>
    <section>
      <file-upload [label]="'transfer-wizard.upload.file' | translate"
        [uploadedFiles]="uploadedFiles"
        [hideUploadedFiles]="false"
        [maxFiles]="1" />
    </section>
    <section>
      <button ghost [loader]="false" [ignoreValidation]="true" (click)="previousStep()">{{ 'transfer-wizard.previous-step' | translate }}</button>
      <button #uploadButton [ignoreValidation]="true" [active]="uploadedFiles.length == 1" (click)="completeUpload()">{{ 'transfer-wizard.next-step' | translate }}</button>
    </section>
  </panel>
}

<!-- Step: reviewTransfer -->
@if (currentStep == steps.reviewTransfer) {
  <panel width="900">
    <h1>{{ 'transfer-wizard.review.header' | translate }}</h1>
    <h2>{{ 'transfer-wizard.review.plans-to-transfer' | translate }}</h2>
    <ng-container *ngTemplateOutlet="companyPlansList; context:{ plans: selectedPlans, review: true }" />
    <h2>{{ 'transfer-wizard.review.transfer-declaration' | translate }}</h2>
    <list-view [selectable]="false" emptyLabel="">
      <list-item info statusIcon="download" [clickable]="true" (action)="downloadTransferDeclaration()">	{{ 'transfer-wizard.review.transfer-declaration' | translate }} {{ getTransferDeclarationFileName() }}	</list-item>
    </list-view>
    <section>
      <div>
        <h2>{{ 'transfer-wizard.review.from-company' | translate }}</h2>
        <company-information [company]="fromCompany" />
      </div>
      <div>
        <h2>{{ 'transfer-wizard.review.to-company' | translate }}</h2>
        <company-information [company]="toCompany" />
      </div>
    </section>
    <section>
      <button ghost [loader]="false" [ignoreValidation]="true" (click)="previousStep()">{{ 'transfer-wizard.previous-step' | translate }}</button>
      <button #createTransferButton [ignoreValidation]="true" (click)="completeTransfer()">{{ 'transfer-wizard.complete-transfer' | translate }}</button>
    </section>
  </panel>
}

<!-- Template for productplans -->
<ng-template #companyPlansList let-plans="plans" let-parentList="parentList" let-parent="parent" let-review="review">
  @if (plans) {
    <list-view #listView scrollable [referenceName]="parentList ? 'childs-to-' + parent : 'main'" [parentList]="parentList" [selectable]="false">
      <header [sortColumn]="false">{{ 'company.product-plans.product-name' | translate }}</header>
      <header [sortColumn]="false">{{ 'company.accounting-plans.start-date' | translate }}</header>
      <header [sortColumn]="false" defaultSort="descending">{{ 'company.accounting-plans.end-date' | translate }}</header>
      <header [sortColumn]="false" align-right>{{ 'company.accounting-plans.interval-months' | translate }}</header>
      <header [sortColumn]="false" align-right>{{ 'company.accounting-plans.annual-contract-value' | translate }}</header>
      <header [sortColumn]="false" align-right>{{ 'company.accounting-plans.total-value' | translate }}</header>
      <row *listData="let plan from plans"
        [clickable]="!review"
        [highlighted]="!review && selectedPlans.indexOf(plan) >= 0"
        (action)="toggleSelectedPlan(plan)"
        [hidden]="!showPlan(plan, !parentList)"
        [showCollapseIcon]="true"
        [statusIcon]="getIcon(plan)"
        [statusColor]="getStatusColor(plan)">
        <column>{{ plan | productName }}</column>
        <column [sortValue]="activeAccountingPlans.get(plan)?.startDate">{{ activeAccountingPlans.get(plan)?.startDate | customDate: 'shortDate' }}</column>
        <column [sortValue]="activeAccountingPlans.get(plan)?.endDate">{{ (plan.autoRenewable ? activeAccountingPlans.get(plan)?.endDate : undefined) | customDate: 'shortDate' }}</column>
        <column align-right>{{ (activeAccountingPlans.get(plan)?.startDate ? activeAccountingPlans.get(plan)?.paymentInterval : plan.paymentScheme) | paymentInterval }}</column>
        <column align-right [sortValue]="getAnnualContractValue(plan)">{{ getAnnualContractValue(plan) | currency }}</column>
        <column align-right [sortValue]="activeAccountingPlans.get(plan)?.totalPlanValue">{{ activeAccountingPlans.get(plan)?.totalPlanValue | currency }}</column>
        @if (plan.inverseParent && plan.inverseParent.length > 0) {
          <ng-container *ngTemplateOutlet="companyPlansList; context:{ plans: plan.inverseParent, parentList: listView, parent: plan.id, review: review}" />
        }
      </row>
    </list-view>
  }
</ng-template>
